type BusPositionResponse = {
	hr: string;
	vs: {
		a: boolean;
		b: boolean;
		is: null;
		p: string;
		px: number;
		py: number;
		sv: null;
		ta: string;
	}[];
};

export type BusPositionData = {
	a: boolean;
	b: boolean;
	is: null;
	p: string;
	px: number;
	py: number;
	sv: null;
	ta: string;
};

export default async function getBusesPos(lineCode: number) {
	const dataResponse = await fetch(
		'/api-proxy/data/Posicao/Linha?CodigoLinha=' + lineCode,
	);

	if (!dataResponse.ok || dataResponse.body === null) return [];

	const fullData: BusPositionResponse = await dataResponse.json();
	
	if (!fullData || !fullData.vs) return [];
	const data: BusPositionData[] = fullData.vs;

	return data;
}
